function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__a",
  d: "M0 101.714h119.429V.571H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__c",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__e",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__g",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__i",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__k",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__m",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__o",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}), /*#__PURE__*/React.createElement("path", {
  id: "dropped-icecream_svg__q",
  d: "M39.428 13.408L.571 32.48l19.632 19.475 19.631 19.474L59.06 32.883 72 6.94 65.582.571"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.214 26.857)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD6C9",
  d: "M51.69 74.63c-8.034 7.922-21.06 7.922-29.093 0a20.086 20.086 0 010-28.688c8.034-7.923 21.06-7.923 29.092 0a20.086 20.086 0 010 28.688"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5636",
  d: "M68.832 92.344c-8.034 7.922-21.059 7.922-29.093 0a20.088 20.088 0 010-28.688c8.034-7.922 21.06-7.922 29.093 0a20.088 20.088 0 010 28.688"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  d: "M108 13.848l-6.419-6.419-26.152 12.94-38.858 19.225 19.632 19.632 19.631 19.631L95.06 40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BF3939",
  d: "M50.271 98.286c3.287-7.462 1.888-16.499-4.21-22.613-7.924-7.945-20.77-7.945-28.694 0-6.097 6.114-7.497 15.15-4.21 22.613H50.27z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BF3939",
  d: "M0 101.714h89.714v-4.571H0z",
  mask: "url(#dropped-icecream_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(58.214 33.143)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M13.429-6.286v84.572",
  mask: "url(#dropped-icecream_svg__d)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M31.714-6.286v84.572",
  mask: "url(#dropped-icecream_svg__f)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M49.429-6.286v84.572",
  mask: "url(#dropped-icecream_svg__h)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M68.286-6.286v84.572",
  mask: "url(#dropped-icecream_svg__j)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M83.429 8.286H-1.714",
  mask: "url(#dropped-icecream_svg__l)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__m"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M83.429 26.571H-1.714",
  mask: "url(#dropped-icecream_svg__n)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__o"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M83.429 44.286H-1.714",
  mask: "url(#dropped-icecream_svg__p)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "dropped-icecream_svg__r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dropped-icecream_svg__q"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#F8FBCF",
  strokeWidth: 2,
  d: "M83.429 63.143H-1.714",
  mask: "url(#dropped-icecream_svg__r)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5636",
  d: "M102.352 79.005L84.213 97.143l-4.856-4.856 18.138-18.138a3.435 3.435 0 014.857 4.856"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BF3939",
  d: "M73.781 110.841s3.027 12.618 13.608 12.618c8.438 0 3.884 3.398 3.884 3.398h-65.63v-3.398s8.085-2.319 8.085-8.295c4.86-4.932 20.042-5.297 22.051-4.618 2.01.68 18.002.295 18.002.295"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BF3939",
  d: "M91.421 123.619c4.042 0 4.716-4.19 8.759-4.19 4.042 0 4.62 4.19 7.026 4.19 2.07 2.145-.963 2.095-.963 2.095H94.79s-7.411-2.095-3.369-2.095"
}));

const SvgDroppedIcecream = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 161,
  height: 160
}, props), _ref, _ref2);

export default SvgDroppedIcecream;